<script lang="ts">
  import { link } from 'svelte-spa-router'
  import { tStore } from '../i18n'
</script>

<section class="not-found">
  <h2>{$tStore('views.notFound.title')}</h2>
  <p>{$tStore('views.notFound.message')}</p>
  <a href="/" use:link>&larr; {$tStore('nav.browse')}</a>
</section>

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .not-found {
    max-width: 480px;
    margin: v.$space-2xl auto;
    text-align: center;
  }
</style>
